import { AccountInput, Operation } from '../../../__generated__/globalTypes'

import {
  AccountFragment,
  accountFragmentString,
} from '../../fragments/__generated__/AccountFragment'

import { creditCardFragmentString } from '../../fragments/__generated__/CreditCardFragment'

import { sponsorFragmentString } from '../../fragments/__generated__/SponsorFragment'

import { storefrontString } from '../../fragments/__generated__/Storefront'

import { addressFragmentString } from '../../fragments/__generated__/AddressFragment'

import { stripeSourceFragmentString } from '../../fragments/__generated__/StripeSourceFragment'

import createAccountRawString from '../CreateAccount.graphql'

const createAccountString = [
  createAccountRawString,
  accountFragmentString,
  creditCardFragmentString,
  sponsorFragmentString,
  storefrontString,
  addressFragmentString,
  stripeSourceFragmentString,
].join('\n\n')

export type CreateAccountData = {
  createAccount: {
    account: AccountFragment
  }
}

export type CreateAccountVariables = {
  account: AccountInput
}

export type CreateAccount = Operation<CreateAccountData, CreateAccountVariables>

export const CreateAccount = ({
  account,
}: CreateAccountVariables): CreateAccount => ({
  query: createAccountString,
  variables: {
    account: AccountInput(account),
  },
})
